// ============================================================================
// payroll-targets — somme / reste / depassement des cibles d'equipe (AD-D2 D5)
// ============================================================================
// Fonctions PURES : Record<string, string> = etat du formulaire (points 0..100
// saisis). Le serveur refuse si la somme des FRACTIONS > 1 + 1e-9 (targets_sum,
// AUCUNE ecriture). L'UI doit desactiver Enregistrer AVANT ce 400.
//
// Distinct de lib/salary/payroll-targets.ts (masse reelle vs cibles deja
// enregistrees) — ne pas fusionner.

/** Vide ou non numerique -> ignore (0). */
export function parseTeamTargetPoints(raw: string): number {
  const trimmed = raw.trim();
  if (trimmed === '') return 0;
  const n = Number(trimmed);
  return Number.isFinite(n) ? n : 0;
}

export function sumTeamTargetPoints(teamPts: Record<string, string>): number {
  return Object.values(teamPts).reduce((s, v) => s + parseTeamTargetPoints(v), 0);
}

/** Arrondi a 1 decimale (parite affichage toPoints). */
export function roundPoints(n: number): number {
  return Math.round(n * 10) / 10;
}

export function remainingTeamTargetPoints(teamPts: Record<string, string>): number {
  return roundPoints(100 - sumTeamTargetPoints(teamPts));
}

/** Somme > 100 points : le serveur refuserait. Exactement 100 et en dessous : OK. */
export function isTeamTargetsOver100(teamPts: Record<string, string>): boolean {
  return sumTeamTargetPoints(teamPts) > 100;
}
